import { ReduxState } from "../store";

export const selectWelcomeStep = (state: ReduxState) => state.general.welcomeStep;
export const selectNotification = (state: ReduxState) => state.general.notification;
export const selectFileId = (state: ReduxState) => state.general.fileId;
export const selectJobInfo = (state: ReduxState) => state.general.jobInfo;
export const selectJobInfoLoading = (state: ReduxState) => state.general.jobInfoLoading;
export const selectLegalTab = (state: ReduxState) => state.general.legalTab;
export const selectSmallScreenWarningModal = (state: ReduxState) => state.general.smallScreenWarningModal;
